import { Box, KeyboardDatePicker, MaterialUiPickersDate } from '@forgeglobal/design-framework'
import { IDateParams } from 'ag-grid-community'
import React, { Component } from 'react'
import moment from 'moment'

export class TableMuiDatePicker extends Component<IDateParams> {
  state = {
    date: null,
  } as { date: null | Date }

  constructor(props: IDateParams) {
    super(props)
    const appliedModel = this.props.filterParams.api.getFilterInstance(this.props.filterParams.column.getId())
    const oldDateString = (appliedModel as any)?.appliedModel?.dateFrom
    const dateState = oldDateString ? moment(oldDateString).toDate() : null
    this.state = {
      date: dateState,
    }
  }

  render() {
    return (
      <Box mt={2}>
        <KeyboardDatePicker
          autoOk
          variant="inline"
          inputVariant="outlined"
          placeholder="MM/DD/YYYY"
          format="MM/DD/YYYY"
          value={this.state.date}
          onChange={this.onChange}
        />
      </Box>
    )
  }

  //*********************************************************************************
  //          METHODS REQUIRED BY AG-GRID
  //*********************************************************************************
  onChange = (date: MaterialUiPickersDate | null, value?: string | null) => {
    if (date && date.isValid()) {
      this.setState({ date: date ? date.toDate() : null }, this.props.onDateChanged)
    }
  }
  getDate(): any {
    //ag-grid will call us here when in need to check what the current date value is hold by this
    //component.
    return this.state.date
  }

  setDate(date: Date | null) {
    //ag-grid will call us here when it needs this component to update the date that it holds.
    this.setState({ date })
  }

  //*********************************************************************************
  //          LINKS THE INTERNAL STATE AND AG-GRID
  //*********************************************************************************

  updateAndNotifyAgGrid(date: Date | null) {
    this.setState(
      {
        date,
      },
      //Callback after the state is set. This is where we tell ag-grid that the date has changed so
      //it will proceed with the filtering and we can then expect ag-Grid to call us back to getDate
      this.props.onDateChanged
    )
  }

  //*********************************************************************************
  //          LINKING THE UI, THE STATE AND AG-GRID
  //*********************************************************************************

  onDateChanged = (selectedDates: Date[] | null[]) => {
    this.setState({ date: selectedDates[0] })
    this.updateAndNotifyAgGrid(selectedDates[0])
  }
}
